import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wpe_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  const guest = localStorage.getItem("wpe_guest_token");
  if (guest) {
    cfg.headers = cfg.headers || {};
    cfg.headers["X-Guest-Token"] = guest;
  }
  return cfg;
});

export default client;

export const getConfig = () => client.get("/config").then((r) => r.data);
export const listScenarios = (industry) =>
  client.get("/scenarios", industry ? { params: { industry } } : undefined).then((r) => r.data);
export const getScenario = (id) => client.get(`/scenarios/${id}`).then((r) => r.data);
export const signup = (email, password) => client.post("/auth/signup", { email, password }).then((r) => r.data);
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const me = () => client.get("/auth/me").then((r) => r.data);
export const setOnboarding = (payload) => client.post("/auth/onboarding", payload).then((r) => r.data);
export const updateProfile = (payload) => client.post("/auth/profile", payload).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  client.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const exportData = () => client.get("/data/export").then((r) => r.data);
export const deleteAccount = () => client.delete("/auth/account").then((r) => r.data);
export const getHome = () => client.get("/home").then((r) => r.data);
export const listPhrases = () => client.get("/phrases").then((r) => r.data);
export const addPhrase = (payload) => client.post("/phrases", payload).then((r) => r.data);
export const deletePhrase = (id) => client.delete(`/phrases/${id}`).then((r) => r.data);
export const reviewPhrase = (phrase_id, learner_text, audio_used = false) =>
  client.post("/phrases/review", { phrase_id, learner_text, audio_used }).then((r) => r.data);
export const generateCustomScenario = (payload) =>
  client.post("/scenarios/custom/generate", payload).then((r) => r.data);
export const listCustomScenarios = () => client.get("/scenarios/custom").then((r) => r.data);
export const deleteCustomScenario = (id) => client.delete(`/scenarios/custom/${id}`).then((r) => r.data);
export const submitIssue = (text, context) =>
  client.post("/issues", { text, context }).then((r) => r.data);
// Admin
export const adminListScenarios = () => client.get("/admin/scenarios").then((r) => r.data);
export const adminCreateScenario = (payload) => client.post("/admin/scenarios", payload).then((r) => r.data);
export const adminUpdateScenario = (id, payload) => client.put(`/admin/scenarios/${id}`, payload).then((r) => r.data);
export const adminPublishScenario = (id) => client.post(`/admin/scenarios/${id}/publish`).then((r) => r.data);
export const adminArchiveScenario = (id) => client.post(`/admin/scenarios/${id}/archive`).then((r) => r.data);
export const adminStats = () => client.get("/admin/stats").then((r) => r.data);
export const adminAudit = () => client.get("/admin/audit").then((r) => r.data);
export const adminListIssues = () => client.get("/issues").then((r) => r.data);
export const adminDashboard = () => client.get("/admin/dashboard").then((r) => r.data);
export const adminListUsers = (q, limit = 50) =>
  client.get("/admin/users", { params: { ...(q ? { q } : {}), limit } }).then((r) => r.data);
export const adminSuspendUser = (id, suspended, reason) =>
  client.post(`/admin/users/${id}/suspend`, { suspended, reason: reason || null }).then((r) => r.data);
export const adminGenerateResetLink = (id) =>
  client.post(`/admin/users/${id}/password-reset`).then((r) => r.data);
export const adminBulkDeleteUsers = (user_ids, confirmation) =>
  client.post("/admin/users/bulk-delete", { user_ids, confirmation }).then((r) => r.data);
export const passwordResetRequest = (email) =>
  client.post("/auth/password-reset/request", { email }).then((r) => r.data);
export const passwordResetConfirm = (token, new_password) =>
  client.post("/auth/password-reset/confirm", { token, new_password }).then((r) => r.data);
export const createSession = (scenario_id, session_level, replay_mode = false) =>
  client
    .post("/sessions", {
      scenario_id,
      ...(session_level ? { session_level } : {}),
      ...(replay_mode ? { replay_mode: true } : {}),
    })
    .then((r) => r.data);
export const getSession = (id) => client.get(`/sessions/${id}`).then((r) => r.data);
export const sendReply = (id, text, audio_used = false) =>
  client.post(`/sessions/${id}/reply`, { text, audio_used }).then((r) => r.data);
export const finishSession = (id) => client.post(`/sessions/${id}/finish`).then((r) => r.data);
export const redoLastAnswer = (id) => client.post(`/sessions/${id}/redo_last_answer`).then((r) => r.data);
export const requestHint = (id) => client.post(`/sessions/${id}/hint`).then((r) => r.data);
export const listSessions = () => client.get("/sessions").then((r) => r.data);
export const deleteSession = (id) => client.delete(`/sessions/${id}`).then((r) => r.data);
export const toggleSaveSession = (id, saved) =>
  client.post(`/sessions/${id}/save`, { saved }).then((r) => r.data);
export const pauseSession = (id, save = false, draft) => {
  const body = { save };
  if (draft !== undefined) body.draft = draft;
  return client.post(`/sessions/${id}/pause`, body).then((r) => r.data);
};
export const resumeSession = (id) =>
  client.post(`/sessions/${id}/resume`).then((r) => r.data);
export const discardSession = (id) =>
  client.post(`/sessions/${id}/discard`).then((r) => r.data);
export const translateTurn = (id, turnIndex, sentenceIndex) =>
  client
    .post(`/sessions/${id}/translate_turn`, {
      turn_index: turnIndex,
      ...(sentenceIndex !== undefined && sentenceIndex !== null ? { sentence_index: sentenceIndex } : {}),
    })
    .then((r) => r.data);
export const retryTurn = (id, originalTurnIndex, newText, audioUsed = false) =>
  client
    .post(`/sessions/${id}/retry`, {
      original_turn_index: originalTurnIndex,
      new_text: newText,
      audio_used: audioUsed,
    })
    .then((r) => r.data);
export const progressSummary = () => client.get("/progress/summary").then((r) => r.data);
export const progressTasks = () => client.get("/progress/tasks").then((r) => r.data);

export const transcribeBlob = async (blob) => {
  const form = new FormData();
  form.append("file", blob, "recording.webm");
  const res = await client.post("/audio/transcribe", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const speak = async (text, speed = 1.0) => {
  const res = await client.post(
    "/audio/speak",
    { text, speed },
    { responseType: "blob" }
  );
  return res.data; // Blob
};
